import React, { useCallback } from 'react';

import Image from '../components/Image/Image';

import styles from './styles.module.scss';

export enum IconPosition {
  Left = 'left',
  Right = 'right',
}
interface Props {
  title: string;
  icon?: any;
  iconPosition?: IconPosition;
  thumbnail?: string;
  enabled?: boolean;
  click: () => void;
}

export default function DetailViewButton({ 
  enabled = true, 
  title, 
  icon, 
  iconPosition, 
  thumbnail, 
  click,
  ...others
}: Props): JSX.Element {
  const onClick = useCallback(() => {
    if (!enabled) return;
    click?.();
  }, [click, enabled]);

  return (
    <button
      onClick={onClick} 
      data-position={iconPosition}
      className={styles.detailViewButton} 
      {...others}
    >
      { thumbnail &&
        <Image
          alt='snapshot from the video'
          className={styles.thumbnail}
          folder='thumbnails'
          filename={thumbnail}
        />
      }
      {icon &&  <span className={styles.icon}>{icon}</span> }
      <span className={styles.title}>{title}</span>

    </button>
  );
}
